import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.market');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { fieldSymbol, PATENT_FIELDS, patentFields, classNumbers, saleMethodLabel } from "src/libs/portal/season/market-catalog";

@Component({
    selector: 'wiz-page-market',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.market/view.scss */
:host {
  display: block;
}

.fairy-home {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 28px 32px;
  color: #193d35;
}

.fairy-home a {
  color: inherit;
  text-decoration: none;
}

.fairy-home a:focus-visible, .fairy-home button:focus-visible {
  outline: 2px solid #8e69aa;
  outline-offset: 4px;
}

.fairy-hero {
  position: relative;
  isolation: isolate;
  width: 100%;
  min-height: 232px;
  margin: 0;
  overflow: hidden;
  background: #16342c;
}

.fairy-hero-inner {
  display: flex;
  align-items: center;
  max-width: 1440px;
  min-height: 232px;
  margin: 0 auto;
  padding: 30px 28px;
}

.fairy-hero-photo {
  position: absolute;
  inset: 0;
  z-index: -2;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 56%;
}

.fairy-hero-shade {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: rgba(8, 25, 22, 0.24);
}

.fairy-hero-copy {
  position: relative;
  min-width: 0;
  max-width: 65%;
  color: #fff;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.24);
}

.fairy-hero .fairy-eyebrow {
  color: #edf4ee;
}

.fairy-eyebrow {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 650;
}

.fairy-hero h1 {
  margin: 0;
  color: #fff;
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.fairy-hero-description {
  margin: 12px 0 0;
  color: #e1ebe4;
  font-size: 13px;
  line-height: 1.7;
}

.fairy-services {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin: 18px 0 32px;
}

.fairy-service {
  display: flex;
  flex-direction: column;
  padding: 20px 22px;
  border: 1px solid #e2e8e1;
  border-radius: 13px;
  background: #fff;
}

.fairy-service:hover {
  border-color: #b7cda8;
  background: #fafcf8;
}

.fairy-service-number {
  color: #8b6aa0;
  font-size: 11px;
  font-weight: 750;
}

.fairy-service h2 {
  margin: 8px 0;
  font-size: 17px;
  font-weight: 750;
}

.fairy-service p {
  margin: 0 0 14px;
  max-width: 320px;
  font-size: 12px;
  line-height: 1.8;
  color: #718077;
}

.fairy-service-link {
  margin-top: auto;
  font-size: 11px;
  font-weight: 650;
}

.fairy-section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.fairy-section-heading .fairy-eyebrow {
  font-size: 10px;
  letter-spacing: 0.12em;
  color: #8c9b89;
}

.fairy-section-heading h2 {
  margin: 0;
  font-size: 23px;
  font-weight: 750;
  letter-spacing: -0.04em;
}

.fairy-view-all {
  padding: 8px 12px;
  border: 1px solid #d5e1d0;
  border-radius: 8px;
  font-size: 11px;
  white-space: nowrap;
  background: #fff;
}

.fairy-category-navigation {
  margin-bottom: 18px;
  border: 1px solid #dfe7dc;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.fairy-category-row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e8ede5;
}

.fairy-category-row:last-child {
  border: 0;
}

.fairy-category-title {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 165px;
  padding: 15px 18px;
  background: #edf3e7;
  font-size: 13px;
  font-weight: 750;
}

.fairy-category-row:last-child .fairy-category-title {
  background: #f2eef6;
}

.fairy-field-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
}

.fairy-field-links a {
  padding: 8px 11px;
  border: 1px solid #e4e9df;
  border-radius: 7px;
  font-size: 11px;
}

.fairy-field-links a:hover {
  background: #eff5e9;
  border-color: #b4cda4;
}

.fairy-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.fairy-listing-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid #dfe7dc;
  border-radius: 13px;
  background: #fff;
  overflow: hidden;
}

.fairy-listing-card:hover {
  border-color: #adc3a3;
  box-shadow: 0 6px 20px rgba(27, 59, 48, 0.062745098);
}

.fairy-card-heading {
  padding: 13px 15px;
  font-size: 11px;
}

.fairy-card-heading > div {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.fairy-card-heading time {
  font-size: 10px;
  color: #8b978e;
}

.fairy-card-heading p {
  margin: 8px 0 0;
  color: #6c8171;
  line-height: 1.5;
}

.fairy-card-heading p span {
  color: #347149;
  font-weight: 750;
}

.fairy-card-heading p span.is-sold {
  color: #8b8e93;
}

.fairy-card-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  background: #f2f6ed;
  color: #8c998a !important;
  font-size: 12px;
}

.fairy-card-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #fff;
}

.fairy-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 14px 16px;
}

.fairy-card-body h3 {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 700;
}

.fairy-card-body h3 a {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.fairy-card-body > p {
  margin: 0;
  color: #8c998d;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.fairy-card-price {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  padding-top: 18px;
  margin-top: auto;
}

.fairy-card-price strong {
  font-size: 17px;
  font-weight: 750;
}

.fairy-card-price small {
  color: #879283;
  font-size: 10px;
}

.fairy-card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 15px;
  border-top: 1px solid #edf1e9;
  font-size: 11px;
}

.fairy-card-actions button {
  padding: 8px 12px;
  border: 1px solid #cbdcbc;
  border-radius: 7px;
  color: #3e6d35;
  background: #f3f8ed;
  font-weight: 650;
}

.fairy-card-actions button:disabled {
  opacity: 0.5;
  cursor: default;
}

.fairy-list-state {
  padding: 25px;
  color: #7d8a7a;
  border: 1px dashed #d6e1ce;
  border-radius: 12px;
  font-size: 12px;
  text-align: center;
}

.fairy-list-state button {
  padding: 8px 12px;
  border: 1px solid #d6e1ce;
  border-radius: 7px;
  background: #fff;
}

.fairy-company {
  width: 100%;
  margin: 0;
  border-top: 1px solid #25483c;
  color: #c9d6ce;
  background: #18352d;
  font-size: 12px;
  line-height: 1.65;
}
.fairy-company a {
  color: inherit;
  text-decoration: none;
  transition: color 0.16s ease;
}
.fairy-company a:focus-visible {
  outline: 2px solid #c3d7ad;
  outline-offset: 3px;
}
.fairy-company h2 {
  margin: 0 0 8px;
  color: #a9bfb2;
  font-size: 12px;
  font-weight: 650;
}

.fairy-footer-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 22px 28px 14px;
}

.fairy-footer-top {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 28px;
  padding-bottom: 16px;
}
.fairy-footer-top > * {
  min-width: 0;
}

.fairy-footer-wordmark {
  display: inline-block;
  color: #fff !important;
  font-size: 25px;
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1.2;
}

.fairy-footer-tagline {
  margin: 8px 0 0;
  color: #dce6df;
  font-size: 12px;
}

.fairy-footer-links > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 18px;
}
.fairy-footer-links a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 24px;
  font-size: 12px;
}
.fairy-footer-links a:hover {
  color: #fff;
}

.fairy-footer-arrow {
  color: #9db5a7;
  font-size: 12px;
}

.fairy-footer-phones {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 14px;
}
.fairy-footer-phones a {
  color: #fff;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.5;
  letter-spacing: -0.015em;
  white-space: nowrap;
}
.fairy-footer-phones a:hover {
  color: #d3e3bf;
}

.fairy-footer-email {
  display: inline-block;
  margin-top: 6px;
  color: #c1d0c6 !important;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.fairy-footer-email:hover {
  color: #fff !important;
}

.fairy-footer-business {
  padding: 13px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.13);
  border-bottom: 1px solid rgba(255, 255, 255, 0.13);
}
.fairy-footer-business address {
  margin: 4px 0 0;
  color: #a9bfb2;
  font-size: 11px;
  line-height: 1.7;
  font-style: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.fairy-footer-business-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 20px;
}

.fairy-footer-company-name {
  color: #edf2ee;
  font-size: 12px;
  font-weight: 650;
}

.fairy-footer-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 20px;
  margin: 0;
  font-size: 11px;
}
.fairy-footer-facts > div {
  display: flex;
  gap: 8px;
}
.fairy-footer-facts dt {
  color: #a9bfb2;
}
.fairy-footer-facts dd {
  margin: 0;
  color: #d4dfd7;
}

.fairy-footer-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 18px;
  padding-top: 10px;
  color: #a9bfb2;
  font-size: 10px;
}

.fairy-footer-bottom p {
  margin: 0;
}

@media (max-width: 760px) {
  .fairy-footer-inner {
    padding: 18px 14px 13px;
  }
  .fairy-footer-top {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 22px;
    padding-bottom: 14px;
  }
  .fairy-footer-brand {
    grid-column: 1/-1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
  }
  .fairy-footer-wordmark {
    font-size: 23px;
    white-space: nowrap;
  }
  .fairy-footer-tagline {
    max-width: 190px;
    margin: 0;
    font-size: 11px;
  }
  .fairy-footer-links > div {
    grid-template-columns: 1fr;
    gap: 1px;
  }
  .fairy-footer-links a {
    min-height: 22px;
    font-size: 11px;
  }
  .fairy-footer-phones {
    flex-direction: column;
    gap: 1px;
  }
  .fairy-footer-phones a {
    font-size: 15px;
  }
  .fairy-footer-business {
    padding: 11px 0;
  }
  .fairy-footer-business-row {
    gap: 5px 16px;
  }
  .fairy-footer-bottom {
    font-size: 9px;
  }
}
.market-auth-overlay {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(16, 43, 37, 0.4);
  backdrop-filter: blur(4px);
}

.market-auth-modal {
  position: relative;
  width: 440px;
  max-width: 100%;
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 20px 80px rgba(16, 43, 37, 0.2);
}

.market-auth-close {
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 5px;
  color: #7b8a80;
}

.market-auth-close svg {
  width: 20px;
  height: 20px;
}

.market-auth-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px;
  background: #f1f6ed;
  color: #688d4d;
}

.market-auth-visual svg {
  width: 30px;
  height: 30px;
}

.market-auth-visual small {
  letter-spacing: 0.12em;
  font-size: 10px;
}

.market-auth-content {
  padding: 28px;
}

.market-auth-label {
  font-size: 11px;
  color: #83947a;
}

.market-auth-content h2 {
  margin: 10px 0;
  font-size: 22px;
  font-weight: 750;
}

.market-auth-content p {
  color: #7c8877;
  font-size: 13px;
  line-height: 1.9;
}

.market-auth-actions {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}

.market-auth-actions button {
  flex: 1;
  padding: 12px;
  border: 1px solid #d7e1d0;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 650;
}

.market-auth-actions button:first-child {
  color: #fff;
  background: #214d3d;
  border-color: #214d3d;
}

@media (max-width: 1199px) {
  .fairy-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .fairy-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .fairy-category-title {
    width: 145px;
  }
  .fairy-service {
    padding: 17px;
  }
}
@media (max-width: 600px) {
  .fairy-home {
    padding: 0 14px 28px;
  }
  .fairy-hero {
    min-height: 224px;
  }
  .fairy-hero-inner {
    min-height: 224px;
    padding: 22px 14px;
  }
  .fairy-hero-copy {
    max-width: none;
  }
  .fairy-hero-photo {
    object-position: 70% center;
  }
  .fairy-hero-shade {
    background: rgba(8, 24, 20, 0.58);
  }
  .fairy-hero h1 {
    font-size: 30px;
  }
  .fairy-hero .fairy-eyebrow {
    max-width: 185px;
    font-size: 12px;
    line-height: 1.8;
  }
  .fairy-hero-description {
    font-size: 11px;
    line-height: 1.7;
  }
  .fairy-services {
    grid-template-columns: 1fr;
    gap: 9px;
    margin-bottom: 25px;
  }
  .fairy-service {
    position: relative;
    padding: 16px;
  }
  .fairy-service h2 {
    font-size: 16px;
  }
  .fairy-service p {
    max-width: none;
    margin-bottom: 0;
    font-size: 11px;
  }
  .fairy-service-link {
    position: absolute;
    top: 17px;
    right: 16px;
    font-size: 10px;
  }
  .fairy-section-heading h2 {
    font-size: 18px;
  }
  .fairy-view-all {
    font-size: 10px;
    padding: 7px 8px;
  }
  .fairy-category-row {
    flex-direction: column;
  }
  .fairy-category-title {
    width: auto;
    padding: 11px 14px;
    font-size: 12px;
  }
  .fairy-field-links {
    gap: 6px;
    padding: 12px;
  }
  .fairy-field-links a {
    padding: 7px 9px;
    font-size: 10px;
  }
  .fairy-card-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .fairy-card-image {
    height: 200px;
  }
}
.fairy-service-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.fairy-service-top h2 {
  margin-bottom: 0;
}

.fairy-category-title {
  gap: 8px;
}

.fairy-category-title .fairy-symbol {
  width: 32px;
  height: 32px;
}

.fairy-field-links a.fairy-field-label {
  display: inline-flex;
}

.fairy-home .fairy-view-all {
  display: inline-flex;
  align-items: center;
}

@media (max-width: 600px) {
  .fairy-service-top {
    padding-right: 2px;
    margin-top: 5px;
  }
  .fairy-service-link {
    top: 17px;
  }
  .fairy-category-title .fairy-symbol {
    width: 28px;
    height: 28px;
  }
}
@media (max-width: 600px) {
  .fairy-service-link {
    position: static;
    display: block;
    margin-top: 10px;
  }
}
.fairy-card-heading p span.is-example {
  color: #866124;
}

.fairy-card-body > p.fairy-card-example-note {
  margin-top: 5px;
  color: #866124;
  font-size: 10px;
}`],
})
export class PageMarketComponent implements OnInit {
    public fieldSymbol = fieldSymbol;
    public technologyFields = PATENT_FIELDS;
    public listings: any[] = [];
    public loading = true;
    public errorMessage = '';
    public authModalOpen = false;
    public authActionLabel = '회원 전용 기능';
    public infoMenus = [
        { label: '공지사항', link: '/market/info/notice' },
        { label: '이용절차·비용', link: '/market/info/process' },
        { label: '사업정보', link: '/market/info/business' },
        { label: '회원소식', link: '/market/info/member-news' }
    ];
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        await this.service.init();
        await this.loadListings();
    }
    public get filteredListings() { return this.listings; }
    public async loadListings() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_listings', { page: 1, limit: 8 });
            if (code !== 200) throw new Error(data?.message || '공개 매물을 불러오지 못했습니다.');
            this.listings = (Array.isArray(data?.items) ? data.items : []).sort((a: any, b: any) =>
                (Date.parse(b.publishedAt) || 0) - (Date.parse(a.publishedAt) || 0));
        } catch (error) {
            this.listings = [];
            this.errorMessage = error instanceof Error ? error.message : '공개 매물을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
    public methodLabel(listing: any) { return saleMethodLabel(listing); }
    public rightLabel(listing: any) {
        const type = String(listing.rightType || '').toUpperCase();
        if (/TRADEMARK|상표/.test(type)) return '상표';
        if (/DESIGN|디자인/.test(type)) return '디자인';
        if (/UTILITY|실용/.test(type) && /PATENT|특허/.test(type)) {
            if (listing.registrationNumber?.startsWith('10')) return '특허';
            if (listing.registrationNumber?.startsWith('20')) return '실용신안';
            return '특허/실용신안';
        }
        if (/UTILITY|실용/.test(type)) return '실용신안';
        return /PATENT|특허/.test(type) ? '특허' : '권리';
    }
    public fieldLabel(listing: any) {
        if (['상표', '디자인'].includes(this.rightLabel(listing))) {
            return classNumbers([listing.field, ...(listing.trademarkClasses || []), ...(listing.designClasses || [])]).map((n) => n + '류').join(' · ') || '류 미입력';
        }
        return patentFields(listing.field || listing.category).join(', ');
    }
    public async onImageError(listing: any) { listing.imageFailed = true; await this.service.render(); }
    public formatPrice(price: number) { return price > 0 ? price.toLocaleString() + '원' : '특정 지정가 미등록'; }
    public formatDate(value: string) {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? '-' : new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(date);
    }
    public async requestMemberAction(actionLabel: string, returnUrl: string) {
        if (returnUrl.startsWith('/consult/example-v4-')) return;
        if (await this.service.auth.check()) { location.href = returnUrl; return; }
        this.authActionLabel = actionLabel;
        this.authModalOpen = true;
        await this.service.render();
    }
    public async closeAuthModal() { this.authModalOpen = false; await this.service.render(); }
    public goLogin() { location.href = '/access'; }
    public goSignup() { location.href = '/access?view=signup'; }
}

export default PageMarketComponent;